<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Treaty Reference No. Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                v-bind:search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="key"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              <!-- <template v-slot:item="row"
                ><tr>
                  <td style="width: 50px">
                    <v-checkbox primary hide-details v-model="row.selected" @change="collectItems($event, row.item.ttyNo)"></v-checkbox>
                  </td>
                  <td class="text-xs-left">{{ row.item.ttyNo }}</td>
                  <td class="text-xs-left">{{ row.item.ttyDesc }}</td>
                </tr>
              </template> -->
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected.</div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mr-2" @click="doSelect('All', 'ttyNo')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mr-2" @click="doSelect('', 'ttyNo')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
// import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
// import clone from 'clone'

export default {
  props: {
    ttyRef: String,
    riType: String,
    acctMth: String,
    acctYr: Number,
    helpListTitle: {
      type: String,
      default: 'Treaty Reference No. Helplist'
    }
  },
  data() {
    return {
      labels: {
        searchKey: 'Search',
        riCo: 'Insured Reference',
        desc: 'Full Name'
      },
      filters: {
        searchKey: undefined
      },
      headers: [
        { text: '', align: 'center', value: 'ttyRef' },
        { text: 'Treaty', value: 'ttyNo' },
        { text: 'Description', value: 'ttyDesc' }
      ],
      selected: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    menu: function () {
      this.doInit()
    }
  },
  methods: {
    async doInit() {
      this.resetMessages()
      if (this.ttyRef !== undefined) {
        this.parameter = this.ttyRef.split(',')
      }
      const apiURI = this.menu.getTtyMasterRefListByRiTypeAcctMthYr
      if (apiURI) {
        const expand = {
          riType: this.riType,
          acctMth: this.acctMth,
          acctYr: this.acctYr
        }
        this.loading = true
        if (this.parameter !== this.checkedItems) {
          // CBO: to reset the 'this.checkedItems' if called from different mode
          this.doReset()
          this.checkedItems = this.parameter
        }
        await this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              this.items = []
              this.selectedItems = []
              data.map((ttyMaster) => {
                const convertList = {
                  key: ttyMaster.ttyRef,
                  ttyNo: ttyMaster.ttyRef,
                  ttyDesc: ttyMaster.ttyDesc
                }
                if (this.checkedItems.includes(ttyMaster.ttyRef)) {
                  const paramList = {
                    key: ttyMaster.ttyRef,
                    ttyNo: ttyMaster.ttyRef,
                    ttyDesc: ttyMaster.ttyDesc
                  }
                  this.selectedItems.push(paramList)
                }
                this.items.push(convertList)
              })
            }
            if (this.checkedItems.toString() === 'All') {
              this.doReset()
              this.toggleAll()
            } else {
              this.toggleSelected()
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
    // async fetchData() {
    //   // this.setHeaders()
    //   this.totalItems = 0
    //   this.items = []
    //   const apiUrl = this.menu.getTtyMasterRefListByRiTypeAcctMthYr
    //   if (apiUrl) {
    //     try {
    //       this.loading = true
    //       const { page, itemsPerPage } = this.pagination
    //       const expand = {
    //         page: page - 1,
    //         size: itemsPerPage,
    //         riType: this.ritype,
    //         filter: this.filters.searchKey
    //       }

    //       let massageFilters = clone(this.filters)
    //       const result = await this.$http.get(
    //         filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
    //       )
    //       if (result.data) {
    //         this.totalItems = result.data.dataMap.totalElements
    //         this.items = []
    //         this.selectedItems = []

    //         const { riCoList } = result.data.dataMap
    //         if (riCoList) {
    //           riCoList.map((param) => {
    //             const convertList = {
    //               key: param.riCo,
    //               riCo: param.riCo,
    //               desc: param.desc,
    //               ttyYr: param.ttyYr
    //             }
    //             this.items.push(convertList)

    //             if (this.checkedItems.includes(param.riCo)) {
    //               const selectedInsuredList = {
    //                 key: param.riCo,
    //                 riCo: param.riCo,
    //                 desc: param.desc,
    //                 ttyYr: param.ttyYr
    //               }
    //               this.selectedItems.push(selectedInsuredList)
    //             }
    //           })
    //         }
    //         this.toggleSelected()
    //         this.loading = false
    //       }
    //       this.loading = false
    //     } catch (err) {
    //       const { data } = err.response
    //       if (data) {
    //         this.message(data)
    //       }
    //       this.loading = false
    //     }
    //   } else {
    //     this.errorMessage('The request failed because it is trying to execute an invalid API url.')
    //   }
    // }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>
